module.exports = __webpack_public_path__ + "img/ball-blue.d65c9e07.svg";